import { AirportLocation } from '@reward-platform/flights-schemas'

const formatAirportName = (airport: AirportLocation): string => {
  return `${airport.airportName} (${airport.airportCode})`
}

export default formatAirportName
